import { useContext } from 'react';
import { FavoriteToggleContext, FavoriteToggleContextType } from '#baseMenu/components';

const useFavoriteToggleContext = () => useContext<FavoriteToggleContextType>(FavoriteToggleContext);

export { useFavoriteToggleContext };
